<p>change-training-date works!</p>
